import classNames from 'classnames'
import { ReactNode } from 'react'

import s from './SideMenu.module.scss'

type ISideMenuProps = {
  children: ReactNode
  isOpen?: boolean
  topPosition?: number
}

export const SideMenu = ({ children, isOpen, topPosition }: ISideMenuProps) => {
  return (
    <div className={classNames(s.layout, { [s.open]: isOpen })} style={{ top: topPosition}}>
      <ul className={s.content}>{children}</ul>
    </div>
  )
}
